import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { inject, Injectable, LOCALE_ID } from '@angular/core'
import { Observable } from 'rxjs'

/**
 * Interceptor to add the `Accept-Language` header to all requests, coming from angular's
 * locale (i.e. the one that is settable by the user in the app), instead of the normal
 * browser configuration.
 */
@Injectable()
export class LocaleInterceptor implements HttpInterceptor {
  public readonly locale = inject(LOCALE_ID)

  intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request to add the locale header from the user-controllable value
    const clonedRequest = req.clone({ headers: req.headers.append('Accept-Language', this.locale) })

    // Pass the cloned request instead of the original request to the next handle
    return next.handle(clonedRequest)
  }
}
